import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "./base/HeaderComponent";
import Footer from "./base/FooterComponent";

const CheckoutSuccess = () => {
    const navigate = useNavigate();

    const goToLogin = () => {
        navigate("/login");
    };

    return (
        <div>
            <Header />
            <div className="container text-center py-5">
                <div className="alert alert-success p-5 shadow-lg rounded" style={{'color': 'white', 'background': 'none'}}>
                    <h1 className="display-4">
                        ✅ Pagamento completato!
                    </h1>
                    <p className="lead mt-3">
                        Adesso puoi avviare una chat con l'operatore!
                    </p>
                    <button className="btn btn-primary mt-4" onClick={goToLogin}>
                        Vail al tuo profilo
                    </button>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default CheckoutSuccess;
